<template>
	<el-dialog :visible.sync="visible" class="loginDialog" :append-to-body="true" width="424px" :close-on-click-modal="false">
		<div class="mod-login">
			<div class="login-panel" v-if="modtype == 'LoginPanel'">
				<div class="login-title">
					<h3>
						欢迎来到,<br />
						陕西陕煤检测科技有限公司
					</h3>
				</div>
				<div class="login-form">
					<el-form :model="loginForm" :rules="rules" @keyup.enter.native="submitForm('loginForm')" ref="loginForm">
						<input type="password" hidden autocomplete="new-password" />
						<el-form-item prop="tel">
							<el-input v-model="loginForm.tel" placeholder="手机号">
								<i slot="prefix" class="phoneIcon"></i>
							</el-input>
						</el-form-item>
						<el-form-item prop="password">
							<el-input name="Aaa" :type="!pwdShow ? 'password' : 'text'" v-model="loginForm.password" placeholder="密码" autocomplete="off">
								<i slot="prefix" class="pwdIcon"></i>
								<i slot="suffix" @click.prevent.stop="showPwdHandle(0)" class="eye" :class="!pwdShow ? 'oeye' : 'ceye'"></i>
							</el-input>
						</el-form-item>
						<el-row :gutter="18">
							<el-col :span="15">
								<el-form-item prop="captcha">
									<el-input placeholder="验证码" v-model="loginForm.captcha">
										<i slot="prefix" class="el-input__icon captcha_icon"></i>
									</el-input>
								</el-form-item>
							</el-col>
							<el-col :span="9"><img :src="captchaPath" class="captcha_img" alt="" @click="getCaptcha()" style="cursor: pointer" /></el-col>
						</el-row>
						<div class="towspan">
							<!-- <el-checkbox v-model="checked">记住密码</el-checkbox> -->
							<span style="color: #1460ae; cursor: pointer" @click="changeHandle('ResetPwdPanel')">忘记密码?</span>
							<span style="color: #1460ae; cursor: pointer" @click="goRouter('register')">注册新用户</span>
						</div>
						<el-form-item>
							<el-button type="primary" class="submit_btn" round @click="submitForm('loginForm')">立即登录</el-button>
						</el-form-item>
						<p class="hold">技术支持：</p>
					</el-form>
				</div>
			</div>
			<div class="resetpwd-panel" v-if="modtype == 'ResetPwdPanel'">
				<div class="panel_top">
					<h3><i class="el-icon-back" @click="changeHandle('LoginPanel')"></i> 忘记密码</h3>
				</div>
				<div class="panel_main">
					<el-form :model="resetForm" :rules="resteRules" @keyup.enter.native="submitForm('resetForm')" ref="resetForm">
						<input type="password" hidden autocomplete="new-password" />
						<el-form-item prop="phone">
							<el-input v-model="resetForm.phone" placeholder="手机号">
								<i slot="prefix" class="phoneIcon"></i>
							</el-input>
						</el-form-item>
						<el-form-item prop="captchaPhone">
							<div class="captchabox2">
								<el-input v-model="resetForm.captchaPhone" placeholder="输入验证码"> <i slot="prefix" class="captcha_icon"></i></el-input>
								<span class="captext" @click.stop.prevent="getCaptchaHandle">{{ showText }}</span>
							</div>
						</el-form-item>
						<el-form-item prop="password1">
							<el-input :type="!pwdShow1 ? 'password' : 'text'" v-model="resetForm.password1" placeholder="请设置新密码" autocomplete="off">
								<i slot="prefix" class="pwdIcon"></i>
								<i slot="suffix" @click.prevent.stop="showPwdHandle(1)" class="eye" :class="!pwdShow1 ? 'oeye' : 'ceye'"></i>
							</el-input>
						</el-form-item>
						<el-form-item prop="comfirmPassword">
							<el-input :type="!pwdShow2 ? 'password' : 'text'" v-model="resetForm.comfirmPassword" placeholder="请确认新密码" autocomplete="off">
								<i slot="prefix" class="pwdIcon"></i>
								<i slot="suffix" @click.prevent.stop="showPwdHandle(2)" class="eye" :class="!pwdShow2 ? 'oeye' : 'ceye'"></i>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" class="submit_btn" round @click="submitForm('resetForm')">确认提交</el-button>
						</el-form-item>
						<p class="hold">技术支持：</p>
					</el-form>
				</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import storageUtils from '@/utils/storageUtils.js'
import { isMobile } from '@/utils/validate'
import { RSAEncrypt } from '@/utils'
export default {
	data() {
		var validateMobile = (rule, value, callback) => {
			if (!isMobile(value)) {
				callback(new Error('手机号格式错误'))
			} else {
				callback()
			}
		}
		// var validateConfirmPassword = (rule, value, callback) => {
		//   if (!/\S/.test(value)) {
		//     callback(new Error("确认密码不能为空"));
		//   } else if (this.resteRules.password1 !== value) {
		//     callback(new Error("确认密码与密码输入不一致"));
		//   } else {
		//     callback();
		//   }
		// };
		return {
			ishsow: false,
			checked: true,
			modtype: 'LoginPanel',
			loginForm: {
				tel: '',
				password: '',
				captcha: '',
			},

			rules: {
				tel: [
					{ required: true, message: '登录账户不能为空！', trigger: 'blur' },
					{ validator: validateMobile, trigger: 'blur' },
				],
				password: [{ required: true, message: '密码不能为空！', trigger: 'blur' }],
				captcha: [
					{ required: true, message: '验证码不能为空！', trigger: 'blur' },
					{ min: 4, max: 4, message: '验证码错误', trigger: 'blur' },
				],
			},
			resetForm: {
				phone: '',
				captchaPhone: '',
				password1: '',
				comfirmPassword: '',
			},
			resteRules: {
				phone: [
					{ required: true, message: '手机号不能为空！', trigger: 'blur' },
					{ validator: validateMobile, trigger: 'blur' },
				],
				password1: [{ required: true, message: '密码不能为空！', trigger: 'blur' }],
				captchaPhone: [{ required: true, message: '验证码不能为空！', trigger: 'blur' }],
				comfirmPassword: [{ required: true, message: '确认密码不能为空', trigger: 'blur' }],
			},
			captchaPath: '',
			pwdShow: false,
			pwdShow1: false,
			pwdShow2: false,
			rotationChart: [],

			countdown: 60,
			showText: '获取验证码',
		}
	},
	computed: {
		visible: {
			get() {
				return this.$store.state.loginVisible
			},
			set(val) {
				this.$store.commit('updateLoginVisible', val)
			},
		},
		userInfo: {
			get() {
				return this.$store.state.userInfo
			},
			set(val) {
				this.$store.commit('updateUserInfo', val)
			},
		},
	},
	created() {
		this.getCaptcha()
	},
	methods: {
		// 立即登录
		submitForm(loginForm) {
			this.$refs[loginForm].validate(valid => {
				if (valid) {
					console.log(this.resetForm.password1, this.resetForm.comfirmPassword, '???????')

					if (loginForm == 'resetForm') {
						if (this.resetForm.password1 != this.resetForm.comfirmPassword) {
							this.$message.warning('确认密码与密码输入不一致')
							return
						}
						let params = {
							phone: this.resetForm.phone,
							captchaPhone: this.resetForm.captchaPhone,
							password: RSAEncrypt(this.resetForm.password1),
						}
						this.$http
							.post(this.$api.userApi.updatePwd, params)
							.then(() => {
								this.modtype = 'LoginPanel'
								this.$message({
									message: '修改成功，请重新登录！',
									type: 'success',
								})
							})
							.catch(() => {})
					} else {
						let params = {
							phone: this.loginForm.tel,
							password: RSAEncrypt(this.loginForm.password),
							captcha: this.loginForm.captcha,
						}
						this.$http
							.post(this.$api.shiroApi.login, params)
							.then(({ data }) => {
								this.$cookie.set('X-Web-Token', data.data.token)
								storageUtils.saveUser(data.data.userInfo)
								this.userInfo = data.data.userInfo
								this.$message({
									message: '登录成功！',
									type: 'success',
								})
								this.visible = false
							})
							.catch(() => {
								this.getCaptcha()
							})
					}
				}
			})
		},
		// 获取验证码
		getCaptcha() {
			this.$http.get(this.$api.shiroApi.captcha).then(({ data }) => {
				this.captchaPath = 'data:image/png;base64,' + data.data
			})
		},
		// 获取手机验证码
		getCaptchaHandle() {
			let params = {
				phone: this.resetForm.phone,
			}
			if (!this.resetForm.phone) {
				this.$message({
					message: '请先输入手机号！',
					type: 'warning',
				})
				return
			}
			if (!isMobile(this.resetForm.phone)) return this.$message.warning('手机号格式错误')
			if (this.countdown != 60) return

			this.$http.post(this.$api.userApi.getpCaptcha, params).then(() => {
				this.$message.success('短信发送成功')
				this.countdown = 60
				this.settime()
			})
		},
		settime() {
			//发送验证码倒计时
			let _this = this
			if (_this.countdown == 0) {
				_this.showText = '获取验证码'
				_this.countdown = 60
				return false
			} else {
				_this.showText = _this.countdown + 's'
				_this.countdown = _this.countdown - 1
			}
			setTimeout(function () {
				_this.settime()
			}, 1000)
		},
		// 显示密码
		showPwdHandle(type) {
			type == 0 && (this.pwdShow = !this.pwdShow)
			type == 1 && (this.pwdShow1 = !this.pwdShow1)
			type == 2 && (this.pwdShow2 = !this.pwdShow2)
		},
		changeHandle(mod) {
			if (mod == 'LoginPanel') {
				this.$refs['resetForm'].resetFields()
			} else {
				this.$refs['loginForm'].resetFields()
			}

			this.modtype = mod
		},
		goRouter(name) {
			this.visible = false
			this.$router.push({ name })
		},
	},
}
</script>
<style lang="scss">
.loginDialog {
	.el-dialog {
		border-radius: 32px;
	}
	.el-dialog__body {
		padding: 0;
	}
	.el-form-item__content {
		line-height: 50px;
	}
	.el-input__icon {
		font-size: 18px;
	}
	.el-input__inner {
		height: 50px;
		line-height: 50px;
		border-radius: 30px;
	}
	.el-input__prefix {
		left: 14px;
	}
	.el-input__suffix {
		right: 14px;
	}
	.el-form-item__error {
		left: 20px;
	}
	.el-input--prefix .el-input__inner {
		padding-left: 42px;
	}
	.submit_btn {
		width: 100%;
		height: 50px;
		border-radius: 30px;
		background-color: #1460ae;
		border-color: #1460ae;
		&:hover {
			background-color: #1460ae;
			border-color: #1460ae;
		}
	}
}
</style>

<style lang="scss" scoped>
.mod-login {
	::v-deep .el-carousel {
		height: 100%;

		ul.el-carousel__indicators--horizontal {
			bottom: 92px;
			width: 1200px;
		}
	}

	.login-panel,
	.resetpwd-panel {
		margin: 0 auto;
		padding: 10px 40px;
		border-radius: 4px;
		background-color: #fff;
		box-shadow: 0 1px 2px 0 rgb(0 0 0 / 5%);
		box-sizing: border-box;
		border-radius: 32px;

		.login-title {
			margin-bottom: 25px;

			h3 {
				font-size: 21px;
				line-height: 38px;
				margin-top: 0;
			}
		}

		.login-form {
			//padding: 0 30px;

			.captcha_icon {
				height: 18px;
				width: 18px;
				display: inline-block;
				vertical-align: middle;
				background: url('~@/assets/img/yzm.png') no-repeat center;
			}

			.captcha_img {
				width: 100%;
				height: 50px;
				background: #d9d9d98c;
			}
			.towspan {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 27px;
			}
			.resetpwd {
				color: #1460ae;
				text-align: right;
				margin-bottom: 30px;
				cursor: pointer;
			}

			.eye {
				display: inline-block;
				width: 24px;
				height: 100%;
				background: url('~@/assets/img/ceye.png') no-repeat center;
				cursor: pointer;
			}

			.ceye {
				background: url('~@/assets/img/ceye.png') no-repeat center !important;
			}

			.oeye {
				background: url('~@/assets/img/oeye.png') no-repeat center !important;
			}

			.phoneIcon {
				display: inline-block;
				width: 24px;
				height: 96%;
				background: url('~@/assets/img/phone.png') no-repeat center;
			}

			.pwdIcon {
				display: inline-block;
				width: 24px;
				height: 96%;
				background: url('~@/assets/img/pwd.png') no-repeat center;
			}
		}
		.hold {
			text-align: center;
			color: #8c8c8c;
			background: url('~@/assets/img/logo_.png') no-repeat 66%;
		}
	}
	.resetpwd-panel {
		.panel_top {
			position: absolute;
			top: 20px;
			left: 0;
			text-align: center;
			width: 100%;
			box-sizing: border-box;
			h3 {
				color: #333333;
				font-size: 21px;
				text-align: center;
				margin-top: 0;
				position: relative;
				user-select: none;
				i {
					position: absolute;
					left: 36px;
					font-size: 24px;
					color: #2962b0;
					cursor: pointer;
				}
			}
		}
		.panel_main {
			margin-top: 35px;
		}
		.eye {
			display: inline-block;
			width: 24px;
			height: 100%;
			background: url('~@/assets/img/ceye.png') no-repeat center;
			cursor: pointer;
		}

		.ceye {
			background: url('~@/assets/img/ceye.png') no-repeat center !important;
		}

		.oeye {
			background: url('~@/assets/img/oeye.png') no-repeat center !important;
		}

		.phoneIcon {
			display: inline-block;
			width: 24px;
			height: 96%;
			background: url('~@/assets/img/phone.png') no-repeat center;
		}

		.pwdIcon {
			display: inline-block;
			width: 24px;
			height: 96%;
			background: url('~@/assets/img/pwd.png') no-repeat center;
		}
		.captcha_icon {
			height: 18px;
			width: 18px;
			display: inline-block;
			vertical-align: middle;
			background: url('~@/assets/img/yzm.png') no-repeat center;
		}
	}
}
</style>
